import produce from 'immer';
import { Reducer } from 'redux';
import _, { some } from 'lodash';

import { User, UsersState, UsersTypes } from '../types';

const initialState: UsersState = {
    isLoading: false,
    users: [],
    requestedUserIds: [],
};

const usersReducer: Reducer<UsersState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case UsersTypes.GET_LIST: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.users = action.payload.users;
                break;
            }
            case UsersTypes.REQUEST_GET_LIST: {
                draft.isLoading = true;
                draft.error = undefined;
                break;
            }
            case UsersTypes.ADD_USER: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.users = some(draft.users, (user) => user.uid === action.payload.uid)
                    ? draft.users.map((user) => {
                          return user.uid !== action.payload.uid ? user : action.payload;
                      })
                    : [...draft.users, action.payload];
                break;
            }
            case UsersTypes.REQUEST_ADD_USER: {
                draft.isLoading = true;
                draft.error = undefined;
                break;
            }
            case UsersTypes.DELETE_USER: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.users = _.filter(draft.users, (user) => {
                    return user.uid !== action.payload.uid;
                });
                break;
            }
            case UsersTypes.REQUEST_DELETE_USER: {
                draft.isLoading = true;
                draft.error = undefined;
                break;
            }
            case UsersTypes.EDIT_USER: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.users = _.map(draft.users, (user) => {
                    return user.uid === action.payload.uid ? { ...user, role: action.payload.role } : user;
                });
                break;
            }
            case UsersTypes.REQUEST_EDIT_USER: {
                draft.isLoading = true;
                draft.error = undefined;
                break;
            }
            case UsersTypes.USER_ERROR: {
                draft.isLoading = false;
                draft.error = action.payload.error;
                break;
            }
            case UsersTypes.CLEAR_USER_ERROR: {
                draft.error = undefined;
                break;
            }
            case UsersTypes.REQUEST_GET_USERS_BY_IDS: {
                draft.requestedUserIds = (draft.requestedUserIds ?? []).concat(action.payload.uids);
                break;
            }
            case UsersTypes.GET_USERS_BY_IDS: {
                const newUsers = action.payload as User[];
                draft.requestedUserIds = draft.requestedUserIds.filter((uid) => newUsers.every((u) => u.uid != uid));
                draft.users = draft.users.filter((u) => newUsers.every((nu) => u.uid != nu.uid)).concat(newUsers);
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { usersReducer };
